<template>
  <div class="grid md:justify-between w-full flex-col-reverse grid-flow-col grid-cols-12 md:flex-row min-h-full relative gap-6">
    <section class="bg-white p-4 md:p-8 lg:p-10 col-span-4 rounded-lg step relative">
      <h3 class="lg:text-3xl leading-normal font-semibold">
        All journey start with the board
      </h3>
      <p class="text-lg mt-4 lg:mt-6" style="color: #a8a8a8">
        A board is where work happens in Getboarded. You’ll find your user
        journey, cards, update, and more to keep you organized and on track.
      </p>

      <p class="text-xl mt-4 lg:mt-6" style="color: #5e5b5b">
        Going faster with a pre-build
        <u class="font-semibold cursor-pointer" @click="routeToBoardTemplate"
          >template</u
        >
        or
      </p>

      <div class="flex flex-col mt-4 lg:mt-6" style="color: #3c3c3c">
        <p class="text-xl md:text-2xl font-normal">Enter a board name</p>
        <input
          class="w-full max-w-xs p-4 text-xl mt-3"
          :class="boardNameMissing ? 'error-input' : ''"
          placeholder="e.g: Hiring Board"
          v-model="boardName"
        />
        <p v-if="boardNameMissing" class="text-lg font-normal mt-2 error-text">
          Enter board name
        </p>

        <vs-button
          class="w-1/3 rounded-lg text-xl mt-4 lg:mt-6"
          @click="routeToStepTwo"
          :color="orgData.primaryThemeColor"
          >Next</vs-button
        >
      </div>

      <div class="mt-10 flex justify-end">
        <p class="text-lg md:text-xl cursor-pointer" style="color: #a8a8a8">
          Skip
        </p>
      </div>
    </section>

    <section
      class="p-6 block items-center col-span-8 justify-content-center place-content-center relative w-full place-self-center h-full rounded-lg step bg-white"
    >
      <BoardSkeletonVue :boardTitle="boardName" />
    </section>
  </div>
</template>

<script>
import BoardSkeletonVue from "./component/BoardSkeleton.vue";
import commonMixin from "./mixins/commonMixin";
export default {
  data() {
    return {
      boardNameMissing: false,
    };
  },
  components: {
    BoardSkeletonVue,
  },
  mixins: [commonMixin],
  computed: {
    orgData() {
      return this.$store.state.organization.orgData;
    },
    kanbanData() {
      return this.$store.state.kanban.kanbanData;
    },
  },
  watch: {
    boardName: {
      handler(newVal) {
        if (newVal) {
          this.boardNameMissing = false;
        }
      },
    },
  },
  methods: {
    routeToBoardTemplate() {
      this.$router.push(`/organization/${this.orgData.slug}/board-templates`);
    },
    routeToStepTwo() {
      if (!this.boardName) {
        this.boardNameMissing = true;
      } else {
        let boardId = this.$route.params.boardId;
        const payload = {
          _boardId: boardId,
          title: this.boardName,
        };

        this.$store
          .dispatch("boards/updateBoard", {
            boardObj: payload,
            organizationId: this.orgData._id,
          })
          .then((res) => {
            if (res && res.data && res.data._id) {
              this.$router.push(
                `/organization/${this.orgData.slug}/create-board/${boardId}/step2`
              );
            }
          })
          .catch((err) => {
            throw err;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./styles/step-common.scss";
</style>
